import { render } from "./datawithschedule.vue?vue&type=template&id=6c135790&scoped=true"
import script from "./datawithschedule.vue?vue&type=script&lang=js"
export * from "./datawithschedule.vue?vue&type=script&lang=js"

import "./datawithschedule.vue?vue&type=style&index=0&id=6c135790&scoped=true&lang=css"

import exportComponent from "C:\\Users\\user\\Desktop\\tapit\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c135790"]])

export default __exports__